const preScanIT = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Risultati Pre Scan",
                "body": {
                    "description": "I seguenti risultati sono stati trovati dopo aver eseguito lo scan per questa release, per favore controllali in dettaglio:",
                    "table": {
                        "column": {
                            "trackName": "Nome della Pista",
                            "type": "Tipo",
                            "title": "Titolo",
                            "artists": "Artisti",
                            "album": "Album",
                            "label": "Etichetta",
                            "releaseDate": "Data di Rilascio",
                            "score": "Punteggio (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Piste Segnalate",
                        "music": "Musica",
                        "cover": "Copertina",
                        "signDeclaration": "Per favore firma la dichiarazione per procedere ulteriormente.",
                        "cancelRelease": "Voglio annullare questa release.",
                        "approveRelease": {
                            "point1": "Voglio approvare questa release perché i risultati mostrati sono 100% identici alla mia release / trasferimento dal distributore precedente.",
                            "point2": "Con la presente, dichiaro solenemente, sotto pena di perjuria, che tutti i contenuti che fornisco sono di proprietà della mia società o di me, o che possiedo i diritti e le licenze completi e validi necessari per il loro uso, distribuzione e presentazione.",
                            "point3": "Riconosco e accetto che sono completamente responsabile per qualsiasi conseguenza legale che può derivare dalla presentazione di tali contenuti, compresi ma non limitati a procedure legali, reclami, costi e spese.",
                            "point4": "Riconosco e accetto che i miei dati personali, compresi le informazioni KYC e tutte le altre informazioni rilevanti, possono essere condivisi con partner autorizzati, fornitori di servizi digitali (DSPs), terze parti coinvolte nell'elaborazione di tali contenuti, così come corti, autorità regolamentari e agenzie di applicazione della legge in caso di qualsiasi richiesta, controversia o requisito legale.",
                            "point5": "Riconosco e accetto che Music Link riserva il diritto di immediatamente terminare il mio accordo, senza alcuna compensazione o ulteriore obbligo, se è provato che ho utilizzato questo modulo in modo errato o se qualsiasi parte della mia dichiarazione è falsa, ingannevole o mal rappresentata.",
                        },
                        "noFlaggedTracks": "Nessuna pista segnalata rilevata nello scan precedente, puoi procedere con i passaggi successivi!"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Invia",
                    "close": "Chiudi"
                }
            },
            "performScan": {
                "header": "Esegui Pre-Scan",
                "body": "Per favore confermare che vuoi eseguire lo scan precedente per questa release.",
                "button": {
                    "cancel": "Annulla",
                    "performScan": "Esegui Scan"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Hai annullato la distribuzione della release, quindi è stata rimossa.",
            "admin_pending": "La tua dichiarazione è in attesa di revisione da parte dell'amministratore per ulteriori azioni.",
            "admin_approved": "Il tuo richiesta per distribuire la tua release è stata approvata dal nostro team amministrativo. La release è stata verificata con successo. Ti ringraziamo per la tua dedizione nel garantire precisione e conformità. La release procederà a tutte le store come previsto. Grazie per la tua attenzione ai dettagli e alla nostra conformità.",
            "admin_rejected": "Il tuo richiesta per distribuire la tua release è stata respinta. Dopo un attento esame, la richiesta non soddisfa i nostri requisiti di approvazione. Ti raccomandiamo di rivalutare il contenuto e assicurarti che tutte le condizioni e le implicazioni legali siano affrontate. Grazie per la tua comprensione e collaborazione.",
            "scanInProgress": "Scan in corso, per favore attendi che lo scan si completi.",
            "releaseMustBeReady": "La release deve essere in stato Ready per eseguire lo scan precedente.",
            "errorSubmittingDeclaration": "Errore accaduto durante l'invio della dichiarazione dell'amministratore del pre-scan.",
        }
    }
};

export default preScanIT;